import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpXsrfTokenExtractor } from '@angular/common/http';
import { XSRF_CUSTOM_HEADER_NAME } from '@bp2s/core/consts/xsrf-token.consts';

@Injectable({ providedIn: 'root' })
export class XsrfInterceptor implements HttpInterceptor {
  constructor(
    private tokenExtracter: HttpXsrfTokenExtractor
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const cookieHeaderName = XSRF_CUSTOM_HEADER_NAME;
    const xsrfToken = this.tokenExtracter.getToken();

    if(xsrfToken !== null && !req.headers.has(cookieHeaderName)) {
      req = req.clone({
        headers: req.headers.set(
          cookieHeaderName, xsrfToken
        )
      });
    }

    return next.handle(req);
  }
}
